'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _immutable = require('immutable');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _reduxActions = require('redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)({
  whosTyping: (0, _immutable.Set)(),
  showTypingIndicator: false
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SEND_TYPING_STATE, function (state, action) {
  return state.set('whosTyping', action.payload);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_TYPING_STATE, function (state, action) {
  var newData = action.payload;
  if (!_immutable.Set.isSet(newData)) {
    newData = (0, _immutable.Set)(newData);
  }
  return state.set('whosTyping', newData);
}), _defineProperty(_handleActions, _ActionTypes2.default.SET_SHOW_TYPING_INDICATOR, function (state, action) {
  return state.set('showTypingIndicator', action.payload);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/typing.js
// module id = 520
// module chunks = 0